export default "__VITE_ASSET__C4kJq$NQ__"